import { BaseEntity, JsonApiProperty, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({ type: 'beverage' })
export default class Beverage extends BaseEntity {
  @JsonApiProperty({ resolver: Number }) price = 0.0;
  name = '';
  description = '';
  isExtra = false;
  isTestable = false;

  constructor(
    id?: Beverage['id'],
    name: Beverage['name'] = '',
    description: Beverage['description'] = '',
    price: Beverage['price'] = 0.0,
    isExtra: Beverage['isExtra'] = false,
    isTestable: Beverage['isTestable'] = false
  ) {
    super();
    this.id = id;
    this.name = name;
    this.description = description;
    this.price = price;
    this.isExtra = isExtra;
    this.isTestable = isTestable;
  }
}
